import { createStyles } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles(() =>
  createStyles({
    textIcon: {
      marginTop: '0px',
      marginBottom: '8px',
      position: 'relative',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: 14,
      lineHeight: '16px',
      color: '#2C2D3E',
      verticalAlign: 'center',
      marginLeft: '38px',
    },
  }),
);
